/* Scrolling bar.
   Measures the real content width, clones just enough copies to cover the
   screen, and drives the animation at a constant pixels-per-second speed so
   the pace does not change with the number of items. */

class MarqueeBar extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.mqbar__track');
    if (!this.track) return;

    this.original = this.track.querySelector('.mqbar__list');
    if (!this.original) return;

    this.speed = Number(this.dataset.speed) || 60;

    this.build();

    if ('ResizeObserver' in window) {
      let frame;
      this.observer = new ResizeObserver(() => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.build());
      });
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  build() {
    // Back to a single list before measuring, so widths are never cumulative.
    this.track.querySelectorAll('.mqbar__list').forEach((list, index) => {
      if (index > 0) list.remove();
    });

    const unit = this.original.getBoundingClientRect().width;
    if (!unit) return;

    const viewport = this.getBoundingClientRect().width;

    // Enough copies to cover the screen, plus one so there is always a full
    // list waiting off-screen to slide in. Never fewer than two.
    const copies = Math.max(2, Math.ceil(viewport / unit) + 1);

    for (let i = 1; i < copies; i += 1) {
      const clone = this.original.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(clone);
    }

    // One list width at a constant speed, whatever the content.
    const duration = unit / this.speed;

    this.track.style.setProperty('--mqbar-distance', unit + 'px');
    this.track.style.setProperty('--mqbar-duration', duration + 's');
    this.track.dataset.ready = 'true';
  }
}

if (!customElements.get('marquee-bar')) {
  customElements.define('marquee-bar', MarqueeBar);
}